import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRouterLink,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./calendar.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import moment from "moment-with-locales-es6";
import $ from "jquery";
import { IonicLoaderComponent } from "ionic-loader";
import { useLocalStorage } from "../../hooks";
import chevron_left from "./../../icon/chevron-left-solid.svg";
import chevron_right from "./../../icon/chevron-right-solid.svg";
import lnbp_logo from "./../../icon/icon.png";

const Calendar: React.FC = () => {
  moment.locale("es");

  const [showProgessBar, setShowProgessBar] = useState(false);
  const [needRefresh, setNeedRefresh] = useLocalStorage("needRefresh", true);

  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  var moment_today = moment();

  var moment_current = moment_today.clone();
  const urlParams = new URLSearchParams(window.location.search);
  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    let coffee = new coffeeTools();
    console.log(coffee.test(12333));
    mainController.init();
    setNeedRefresh(false);

    let title_container = document.getElementById("js__title_calendar");
    title_container.innerHTML = "";
    coffee_tools.createSectionTitle("Calendario ", title_container);
  }, [needRefresh]);

  var controller = (() => {
    function getBanner(id_entry, callback) {
      var ajax_data = {
        id: id_entry
      };
      fetch(process.env.REACT_APP_BASE_URL + "/cms/entries/single", {
        method: "POST",
        body: JSON.stringify(ajax_data),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then((data) => {
          callback(data);
        });
    }

    return {
      getBanner: (id_entry, callback) => getBanner(id_entry, callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      banner_image: "js__banner_image"
    };

    /* Banner */
    function displayTopBanner(data) {
      // console.log("displayTopBanner");

      let image = document.getElementById(dom_obj.banner_image);
      image.setAttribute(
        "src",
        process.env.REACT_APP_BASE_URL + data.item.full_url_image
      );

      if (
        data.item.full_url_image != null &&
        !data.item.full_url_image.includes("no-image.jpg")
      ) {
      }
    }

    return {
      displayTopBanner: (id_entry) => displayTopBanner(id_entry)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("Menu started");
        setupEventListeners();

        // page_controller.getBanner(29, page_view.displayTopBanner);
        coffee_tools.showRotateBanner();
        setShowProgessBar(false);
      }
    };
  })(controller, view);

  $(document).ready(function () {
    const page_template_content = document.getElementById(
      "js__page_template_content"
    );

    page_template_content.innerHTML = "";

    //main content
    let row = document.createElement("div");
    row.classList.add("row");
    row.classList.add("calendar_container");
    let col_1 = document.createElement("div");
    col_1.classList.add("col-lg-6", "col-md-6", "col-sm-12");
    // let col_2 = document.createElement("div");
    // col_2.classList.add("col-lg-6", "col-md-6", "col-sm-12");
    col_1.id = "js__calendar_container";

    row.appendChild(col_1);

    let banner_img = document.createElement("img");
    banner_img.id = "js__banner_image";
    row.appendChild(banner_img);
    // col_2 is the event detail
    // row.appendChild(col_2);

    // place the game detail container
    let events_detail = document.createElement("div");
    events_detail.id = "js__calendar_event_detail";
    events_detail.style.visibility = "hidden";
    events_detail.classList.add(
      "cs_content",
      "cs_detail",
      "row",
      "col-sm-12",
      "col-lg-12",
      "col-md-12"
    );

    let events_detail_row_1 = document.createElement("div");
    events_detail_row_1.classList.add("row");

    let events_detail_row_2 = document.createElement("div");
    events_detail_row_2.classList.add("row");

    let events_detail_row_3 = document.createElement("div");
    events_detail_row_3.classList.add("row");

    events_detail.appendChild(events_detail_row_1);
    events_detail.appendChild(events_detail_row_2);
    events_detail.appendChild(events_detail_row_3);

    //this will be inserted on the first row "scoreboard"
    let scoreboard = document.createElement("div");
    scoreboard.classList.add("cs_scoreboard");

    let scoreboard_div = document.createElement("div");
    scoreboard_div.classList.add("cs_opacity_75", "cs_color_4");

    scoreboard.appendChild(scoreboard_div);

    let wrapper = document.createElement("div");
    wrapper.classList.add("cs_wrapper");

    let wrapper_span = document.createElement("span");
    wrapper_span.id = "lbl_vs";
    wrapper_span.classList.add("cs_button");
    wrapper_span.innerText = "VS";

    wrapper.appendChild(wrapper_span);

    let wrapper_table = document.createElement("table");
    let wrapper_table_tr = document.createElement("tr");

    wrapper_table.appendChild(wrapper_table_tr);

    let wrapper_table_td_1 = document.createElement("td");
    let wrapper_table_td_2 = document.createElement("td");

    let img_logo_1 = document.createElement("img");
    img_logo_1.id = "img_logo_1";
    let img_logo_2 = document.createElement("img");
    img_logo_2.id = "img_logo_2";

    wrapper_table_td_1.appendChild(img_logo_1);
    wrapper_table_td_2.appendChild(img_logo_2);

    wrapper_table_tr.appendChild(wrapper_table_td_1);
    wrapper_table_tr.appendChild(wrapper_table_td_2);

    wrapper.appendChild(wrapper_table);

    events_detail_row_1.appendChild(wrapper);

    //second row events_detail_row_2
    let events_detail_row_2_col_1 = document.createElement("div");
    events_detail_row_2_col_1.classList.add("col-sm-6", "cs_detail_map");

    let events_detail_row_2_col_1_div = document.createElement("div");
    events_detail_row_2_col_1_div.id = "div_map";
    events_detail_row_2_col_1_div.classList.add(
      "div_map",
      "row",
      "col-sm-12",
      "col-lg-12",
      "clearfix"
    );
    events_detail_row_2_col_1.appendChild(events_detail_row_2_col_1_div);

    let events_detail_row_2_col_1_a = document.createElement("a");
    events_detail_row_2_col_1_a.id = "btn_map";
    events_detail_row_2_col_1_a.classList.add(
      "btn",
      "btn-dark",
      "cs_button",
      "row",
      "col-sm-12",
      "col-lg-12"
    );
    events_detail_row_2_col_1_a.innerText = "Ver mapa";

    events_detail_row_2_col_1.appendChild(events_detail_row_2_col_1_a);

    events_detail_row_2.appendChild(events_detail_row_2_col_1);

    //second column
    let events_detail_row_2_col_2 = document.createElement("div");
    events_detail_row_2_col_2.classList.add("col-sm-6", "cs_detail_text");

    let events_detail_row_2_col_2_div = document.createElement("div");
    events_detail_row_2_col_2_div.classList.add("div_description");

    let events_detail_row_2_col_2_p = document.createElement("p");
    events_detail_row_2_col_2_p.classList.add("cs_small");
    events_detail_row_2_col_2_p.innerHTML =
      'Del: <span id="lbl_date_start">---</span><br> \
Al: <span id="lbl_date_end">---</span><br> \
Hora: <span id="lbl_time_start">---</span> a <span id="lbl_time_end">---</span><br> \
En: <span id="lbl_venue">---</span>';

    events_detail_row_2_col_2_div.appendChild(events_detail_row_2_col_2_p);
    events_detail_row_2_col_2.appendChild(events_detail_row_2_col_2_div);
    events_detail_row_2.appendChild(events_detail_row_2_col_2);

    //second row events_detail_row_2

    let buttons = [
      // { id: "btn_stats", class: "fi-graph-bar", text: "Minuto a minuto", href:"" },
      { id: "btn_live", class: "fi-video", text: "Ver en vivo" },
      { id: "btn_phone", class: "fi-telephone", text: "Contacto" },
      { id: "btn_web", class: "fi-monitor", text: "Web" }
    ];

    buttons.forEach((item) => {
      let div = document.createElement("div");
      div.classList.add("col-md-4", "mx-auto");

      let a = document.createElement("a");
      a.id = item.id;
      a.classList.add("button", "games_links");

      let i = document.createElement("i");
      i.innerHTML = item.text;
      i.classList.add(item.class, "btn", "btn-dark");
      i.prepend(document.createElement("br"));

      div.appendChild(a);
      a.appendChild(i);
      // a.href = item.href;
      a.classList.add("cs_disabled");
      events_detail_row_3.appendChild(div);
    });

    // col_2.appendChild(events_detail);

    page_template_content.appendChild(row);

    //place the game list container
    let events_list = document.createElement("div");
    events_list.id = "js__calendar_event_list";
    page_template_content.appendChild(events_list);

    function buildCalendar(moment) {
      //clean the calendar
      document.getElementById("js__calendar_container").innerHTML = "";

      var moment_start = moment.startOf("month").clone();
      var moment_end = moment.endOf("month").clone();

      //this is html_row_1
      let header_tr = document.createElement("tr");
      let header_td_title = document.createElement("td");
      header_td_title.innerText = moment.format("MMMM YYYY");
      header_td_title.colSpan = 5;
      header_tr.appendChild(header_td_title);

      let header_td_prev = document.createElement("td");
      header_td_prev.id = "cs_previous_month";
      let header_td_prev_arrow = document.createElement("span");

      header_td_prev_arrow.classList.add("cs_previous_month");
      // tbbm here for chevron
      let img_chevron_left = document.createElement("img");
      img_chevron_left.src = chevron_left;
      img_chevron_left.classList.add("cs_previous_month");
      header_td_prev_arrow.appendChild(img_chevron_left);

      //
      header_td_prev.appendChild(header_td_prev_arrow);
      header_tr.appendChild(header_td_prev);

      let header_td_next = document.createElement("td");
      header_td_next.id = "cs_next_month";
      let header_td_next_arrow = document.createElement("span");
      header_td_next_arrow.classList.add("cs_next_month");

      let img_chevron_right = document.createElement("img");
      img_chevron_right.src = chevron_right;
      img_chevron_right.classList.add("cs_previous_month");
      header_td_next_arrow.appendChild(img_chevron_right);

      header_td_next.appendChild(header_td_next_arrow);
      header_tr.appendChild(header_td_next);

      //this is html_row_2
      let sub_header_tr = document.createElement("tr");
      ["DOM", "LUN", "MAR", "MIER", "JUE", "VIE", "SAB"].map((item) => {
        let td = document.createElement("td");
        td.innerText = item;
        sub_header_tr.appendChild(td);
      });

      let calendar_table = document.createElement("table");

      calendar_table.appendChild(header_tr);
      calendar_table.appendChild(sub_header_tr);

      var moment_curr = moment_start.clone();

      let calendar_table_tr = document.createElement("tr");

      //Fill out the days before the start of the month.
      if (moment_curr.day() > 0) {
        while (moment_curr.day() > 0) {
          //paints day as grey meaning or showing past month days
          moment_curr.subtract(1, "days");

          let td = document.createElement("td");
          td.id = moment_curr.format("YYYY-MM-DD");
          td.classList.add("cs_day", "cs_om");
          td.innerText = moment_curr.format("D");
          calendar_table_tr.prepend(td);
        }

        moment_curr = moment_start.clone();
      }

      //Fill out the days of the month. all gray
      while (moment_curr.isBefore(moment_end)) {
        let td = document.createElement("td");
        td.id = moment_curr.format("YYYY-MM-DD");
        td.classList.add("cs_day");
        td.innerText = moment_curr.format("D");
        calendar_table_tr.appendChild(td);
        moment_curr.add(1, "days");

        //creates the calendar rows
        if (moment_curr.day() === 0 && moment_curr.isBefore(moment_end)) {
          // html_all += "</tr><tr>";
          calendar_table.appendChild(calendar_table_tr);
          calendar_table_tr = document.createElement("tr");
        }
      }
      calendar_table.appendChild(calendar_table_tr);

      //Fill out the days after the end of the month.
      if (moment_curr.day() <= 6) {
        var html_after = "";

        while (moment_curr.day() !== 0) {
          let td = document.createElement("td");
          td.id = moment_curr.format("YYYY-MM-DD");
          td.classList.add("cs_day", "cs_om");
          td.innerText = moment_curr.format("D");
          calendar_table_tr.append(td);
          moment_curr.add(1, "days");
        }
      }
      calendar_table.classList.add("cs_calendar");
      calendar_table.id = "tbl_calendar";
      calendar_table.align = "center";
      //Adjust row height.
      var height = $(".cs_day").height();
      var width = $(".cs_day").width();

      if (height > width) {
        $(".cs_day").width($(".cs_day").height());
      }

      loadGames(moment_start, moment_end);

      document
        .getElementById("js__calendar_container")
        .appendChild(calendar_table);

      //Setup event hooks after the calendar has been appended
      $(".cs_day").on("click", function () {
        var date = $(this).attr("id");

        cs_load_game_list(date, date).then((response) => {
          let news_list_container = document.querySelector(
            "#js__calendar_event_list"
          );
          news_list_container.innerHTML = "";
          news_list_container.appendChild(response as HTMLDivElement);
          //scroll to the calendar list
          document
            .getElementById("js__calendar_event_list")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });

      $("#cs_previous_month").on("click", function (e) {
        moment_current.subtract(1, "months");
        buildCalendar(moment_current);
      });

      $("#cs_next_month").on("click", function (e) {
        moment_current.add(1, "months");
        buildCalendar(moment_current);
      });
    }

    //paints the date
    function loadGames(date_start, date_end) {
      //Prepare the request data.
      var ajax_data = {
        date_start: date_start.format("YYYY_MM-DD"),
        date_end: date_end.format("YYYY_MM-DD")
      };

      $.ajax({
        type: "POST",
        url: base_url + "/sports/games/dates",
        data: ajax_data
      }).done(function (response) {
        //Repeat the events for the dates they occur.
        $.each(response.items, function (i, item) {
          var date_start = moment(item.event.date_start, "YYYY-MM-DD");
          var date_end = moment(item.event.date_end, "YYYY-MM-DD");
          var date_curr = date_start.clone();

          while (date_curr.isBefore(date_end) || date_curr.isSame(date_end)) {
            $("#tbl_calendar #" + date_curr.format("YYYY-MM-DD")).addClass(
              "cs_has_event"
            );
            date_curr.add(1, "days");
          }
        });
      });
    }
    async function cs_load_game_list(date_start, date_end) {
      if (date_start !== undefined) {
        let response = await cs_load_games_dates(date_start, date_end).then(
          (response) => {
            return cs_render_game_list(response, date_start, date_end);
          }
        );
        return response;
      } else {
        let response = await cs_load_games_all().then((response) => {
          // return cs_render_game_list(response);
        });
        return response;
      }
    }
    async function cs_load_games_all() {
      //Prepare the request data.
      var ajax_data = {};

      return $.ajax({
        type: "POST",
        url: base_url + "/sports/games/active",
        data: ajax_data
      });
    }
    async function cs_load_games_dates(date_start, date_end) {
      //Prepare the request data.
      var ajax_data = {
        date_start: date_start,
        date_end: date_end
      };

      return $.ajax({
        type: "POST",
        url: base_url + "/sports/games/dates",
        data: ajax_data
      });
    }

    // //tbbm: understand this and paint events on list
    async function cs_render_game_list(
      response,
      query_date_start,
      query_date_end
    ) {
      // $("#div_list").html("");
      let div_list = document.createElement("div");
      div_list.id = "div_list";

      if (response.items.length > 0) {
        var events = [];
        //Repeat the events for the dates they occur.
        $.each(response.items, function (i, item) {
          var venue = item.event.venue;
          var date_start = moment(item.event.date_start, "YYYY-MM-DD");
          var date_end = moment(item.event.date_end, "YYYY-MM-DD");
          var time_start = moment(item.event.time_start, "hh:mm:ss");
          var time_end = moment(item.event.time_end, "hh:mm:ss");
          var date_curr = date_start;
          var url_live = item.url_live;

          while (date_curr.isBefore(date_end) || date_curr.isSame(date_end)) {
            if (typeof query_date_start === "undefined") {
              events.push({
                id: item.id,
                name: item.name,
                date: date_curr.clone(),
                time_start: time_start,
                time_end: time_end,
                full_url_logo_1: item.team_1.full_url_logo,
                full_url_logo_2: item.team_2.full_url_logo,
                venue: venue,
                url_live: item.url_live
              });
            } else {
              if (
                date_curr.isBefore(query_date_start) ||
                date_curr.isAfter(query_date_end)
              ) {
                //Do nothing.
              } else {
                events.push({
                  id: item.id,
                  name: item.name,
                  date: date_curr.clone(),
                  time_start: time_start,
                  time_end: time_end,
                  full_url_logo_1: item.team_1.full_url_logo,
                  full_url_logo_2: item.team_2.full_url_logo,
                  venue: venue,
                  url_live: item.url_live
                });
              }
            }

            date_curr.add(1, "days");
          }
        });

        //Sort the events.
        events.sort(function (a, b) {
          if (a.date.isBefore(b.date, "day")) return -1;
          if (b.date.isBefore(a.date, "day")) return 1;
          return 0;
        });

        //Display the events.
        $.each(events, function (i, item) {
          var selector_2 = $("#div_" + item.date.format("YYYY-MM-DD"));

          if (selector_2.length === 0) {
            let link = "";
            let linkClass = ["button", "small", "cs_disabled"];

            if (item.url_live != "") {
              link = item.url_live;
              linkClass = ["button", "small"];
            }

            var day_name = item.date.format("DD/MM/YYYY");
            // $("#div_list").append("<div id='div_" + item.date.format("YYYY-MM-DD") + "'><h3>" + day_name + "</h3></div>");
            let list_item = document.createElement("div");
            list_item.id = "div_" + item.date.format("YYYY-MM-DD");

            let list_item_title = document.createElement("h3");
            list_item_title.innerHTML = day_name;
            list_item.appendChild(list_item_title);
            div_list.appendChild(list_item);

            //al list_item tengo que hacerle un apend del template

            let a = document.createElement("a");
            a.href = "/calendar_detail?cs_load_game=" + item.id;
            // a.setAttribute("routerLink", "/calendar_detail?cs_load_game=" + item.id);

            //first row where the title is
            let row_1 = document.createElement("div");
            row_1.classList.add("calendar_game_List_title");

            let row_1_col_2 = document.createElement("div");
            row_1_col_2.classList.add("text-center", "ion-text-center");
            row_1_col_2.innerHTML = item.venue;
            row_1.appendChild(row_1_col_2);

            //second row
            let row_2 = document.createElement("div");
            row_2.classList.add(
              "calendar_game_List_game_details",
              "ion-text-center"
            );

            //first colum time of the game
            let row_2_col_1 = document.createElement("div");
            row_2_col_1.classList.add("ion-text-center");
            row_2_col_1.style.verticalAlign = "middle";
            row_2_col_1.innerHTML = item.time_start.format("hh:mma");

            // logo first team

            let img_1 = document.createElement("img");
            img_1.style.maxWidth = "130px";
            img_1.classList.add("calendar_game_List_team_logo");
            img_1.src = base_url + item.full_url_logo_1;

            //vs
            let game_data_vs = document.createElement("span");
            game_data_vs.classList.add("calendar_game_List_team_vs");
            game_data_vs.innerHTML = "VS";

            //logo second team

            let img_2 = document.createElement("img");
            img_2.src = base_url + item.full_url_logo_2;
            img_2.style.maxWidth = "130px";
            img_2.classList.add("calendar_game_List_team_logo");

            // row_2.appendChild(row_2_col_2);
            row_2.appendChild(img_1);
            row_2.appendChild(game_data_vs);
            row_2.appendChild(img_2);

            //so styles are added to the div
            let link_container = document.createElement("div");
            link_container.classList.add("game_list_item");
            link_container.appendChild(row_1);
            link_container.appendChild(row_2);

            a.appendChild(link_container);
            div_list.appendChild(a);
          }
        });
      } else {
        //$("#lst_games").append("<li class='cs_item cs_message'>No hay eventos en las fechas seleccionadas.</li>");
      }

      return div_list;
    }

    buildCalendar(moment_today);
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div hidden={!showProgessBar}>
          <IonProgressBar type='indeterminate'></IonProgressBar>
        </div>
        <span
          style={{ fontWeight: "bold" }}
          id='js__title_calendar'
        ></span>
        <div id='js__page_template_content'></div>

        <IonRouterLink></IonRouterLink>
      </IonContent>
    </IonPage>
  );
};

export default Calendar;
